import * as React from "react";
import InputBase from "@mui/material/InputBase";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { styled } from "@mui/material/styles";

const CustomInput = styled(InputBase)(
  ({ theme, error, type, haveIncrement }) => ({
    "label + &": {
      marginTop: theme.spacing(2),
      color: "#C85000",
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      backgroundColor: "#ffffff",
      border: `1px solid ${error ? "#d32f2f" : "#E0E3E7"}`,
      fontSize: 13,
      width: "100%",
      padding: "5px 12px",
      marginTop: "10px",
      color: theme.palette.text.primary,
      "&:focus": {
        borderColor: error ? "#d32f2f" : "#1976D2",
      },
      ...((type = "number" && !haveIncrement) && {
        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&[type=number]": {
          "-moz-appearance": "textfield",
        },
      }),
    },
  })
);

export function CTextField({
  name,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  type,
  InputProps,
  disabled,
  defaultValue,
  maxLength,
  readOnly,
  helperText,
  error,
  required,
  haveIncrement = false,
}) {
  return (
    <FormControl variant="standard" fullWidth error={error} required={required}>
      <InputLabel shrink className="colorGnral-red inputLabel-CText">
        {label}
      </InputLabel>
      <CustomInput
        name={name}
        inputProps={InputProps}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        type={type}
        disabled={disabled}
        readOnly={readOnly}
        error={error}
        haveIncrement={haveIncrement}
        onInput={(e) => {
          e.target.value = e.target.value.slice(0, maxLength);
        }}
        size="small"
        fullWidth
      />
      <FormHelperText
        style={{
          color: error ? "#d32f2f" : "#000",
          marginTop: 2,
          fontSize: 10,
        }}
      >
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}
